/* Fiche produit Mush Caps (gabarit product.mush-caps), 2/10/2026. Source : PRODUITS-MUSH-CAPS-2026-09-30/fiche-produit-caps/construire.py
   Choix du pack (boîte, Découverte, Rituel, Ultime), ajout au panier, galerie, barre collante, apparitions.
   Ajout : POST {racine}cart/add.js {items:[{id, quantity:1}]} puis évènement « cart:updated » (le tiroir du thème relit
   /cart.js et s'ouvre, comme les fiches Café / Choco et la collection) ; sans tiroir sur la page : redirection vers le panier.
   Refus de Shopify = message sous le bouton. Le prix payé est toujours celui de Shopify. */
(function () {
  var R = document.getElementById('mng-pdp-caps');
  /* 08/10/2026 (i18n) : textes fournis par la section (attributs data-t-*, snippets/_loc) ; à défaut, le français. */
  function TX(k, d) { var v = R && R.getAttribute('data-t-' + k); return v || d; }
  if (!R) return;
  var RACINE = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  function q(s) { return R.querySelector(s); }
  function qa(s) { return [].slice.call(R.querySelectorAll(s)); }
  function set(k, t) { qa('[data-mc="' + k + '"]').forEach(function (el) { el.textContent = t; }); }

  /* ---------- choix ---------- */
  var opts = qa('.mc-opt'), cta = q('.mc-cta'), err = q('.mc-err'), sel = null;
  opts.forEach(function (o) { if (o.classList.contains('on')) sel = o; });
  if (!sel && opts.length) sel = opts[0];
  var packSlide = q('[data-mcx-pack] img'), packTh = q('[data-mcx-pack-th] img');
  function choisir(o, garderGalerie) {
    sel = o;
    opts.forEach(function (x) {
      var on = x === o;
      x.classList.toggle('on', on);
      x.setAttribute('aria-checked', on ? 'true' : 'false');
      x.tabIndex = on ? 0 : -1;
    });
    var dispo = o.getAttribute('data-dispo') === '1';
    set('cta', o.getAttribute('data-prix'));
    set('cta2', o.getAttribute('data-prix'));
    set('sticky', o.getAttribute('data-nom'));
    if (cta) {
      cta.disabled = !dispo;
      cta.firstChild && cta.firstChild.nodeType === 3 && (cta.firstChild.nodeValue = dispo ? TX('ajouter', 'Ajouter au panier ·') + ' ' : TX('epuise', 'Épuisé ·') + ' ');
    }
    if (err) { err.hidden = true; err.textContent = ''; }
    var img = o.getAttribute('data-img');
    if (img && packSlide) {
      packSlide.src = img; packSlide.alt = o.getAttribute('data-alt') || '';
      if (packTh) packTh.src = o.getAttribute('data-th') || img;
      if (!garderGalerie) montrer(0);
    }
  }
  opts.forEach(function (o, i) {
    o.addEventListener('click', function () { choisir(o); });
    o.addEventListener('keydown', function (e) {
      var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var n = opts[(i + d + opts.length) % opts.length];
      choisir(n); n.focus();
    });
  });

  /* ---------- ajout au panier ---------- */
  var envoi = false, html0 = cta ? cta.innerHTML : '';
  function erreur(t) { if (!err) return; err.textContent = t; err.hidden = !t; }
  if (cta) cta.addEventListener('click', function () {
    if (envoi || !sel || cta.disabled) return;
    var id = parseInt(sel.getAttribute('data-v'), 10);
    if (!id) { erreur(TX('indispo', 'Ce pack est indisponible pour le moment. Écrivez-nous à contact@mushngo.com.')); return; }
    envoi = true; erreur(''); cta.setAttribute('aria-busy', 'true');
    fetch(RACINE + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(null, function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || ('Erreur ' + r.status));
        return j;
      });
    }).then(function () {
      envoi = false; cta.removeAttribute('aria-busy');
      cta.textContent = TX('ajoute', 'Ajouté au panier ✓'); cta.classList.add('added');
      setTimeout(function () { cta.innerHTML = html0; cta.classList.remove('added'); choisir(sel, true); }, 1600);
      if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('cart:updated'));
      else window.location.href = RACINE + 'cart';
    }).catch(function (e) {
      envoi = false; cta.removeAttribute('aria-busy');
      console.error('[mng-pdp-caps] ajout au panier', e);
      erreur((e && e.message) || TX('echec', 'Impossible d\'ajouter ce pack au panier. Réessayez ou écrivez-nous à contact@mushngo.com.'));
    });
  });

  /* ---------- galerie ---------- */
  var S = qa('.mc-slide'), T = qa('.mc-th button'), gi = 0;
  function montrer(i) {
    if (!S.length) return;
    gi = (i + S.length) % S.length;
    S.forEach(function (s, k) { s.classList.toggle('on', k === gi); });
    T.forEach(function (t, k) { t.classList.toggle('on', k === gi); });
    var c = q('.mc-count b'); if (c) c.textContent = gi + 1;
    var th = T[gi], box = th && th.parentNode;
    if (box && box.scrollWidth > box.clientWidth) box.scrollLeft = th.offsetLeft - box.clientWidth / 2 + th.offsetWidth / 2;
  }
  T.forEach(function (b, k) { b.addEventListener('click', function () { montrer(k); }); });
  var pv = q('.mc-prev'), nx = q('.mc-next');
  if (pv) pv.addEventListener('click', function () { montrer(gi - 1); });
  if (nx) nx.addEventListener('click', function () { montrer(gi + 1); });
  var m0 = q('.mc-main'), sx = null;
  if (m0) {
    m0.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    m0.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) montrer(gi + (dx < 0 ? 1 : -1));
      sx = null;
    });
  }

  /* ---------- barre collante : visible une fois le bouton d'achat dépassé, cachée en fin de fiche ---------- */
  var st = document.getElementById('mcsticky'), fin = document.getElementById('mng-pdp-caps-fin');
  if ('IntersectionObserver' in window && st && fin && cta) {
    var v = { c: 1, f: 0 }, u = function () { st.classList.toggle('on', !v.c && !v.f); };
    new IntersectionObserver(function (e) { v.c = e[0].isIntersecting || e[0].boundingClientRect.top > 0; u(); }).observe(cta);
    new IntersectionObserver(function (e) { v.f = e[0].isIntersecting || e[0].boundingClientRect.top < 0; u(); }).observe(fin);
  }

  /* ---------- préparation en 3 étapes (comme la fiche Café) ---------- */
  (function () {
    var stp = qa('.px-steps li'), pi = qa('.px-prep-ph img'), ul = q('.px-steps'), si = 0, tm = null, live = true;
    if (!ul || !stp.length) return;
    function step(i) {
      si = i % stp.length;
      stp.forEach(function (l, k) { l.classList.toggle('on', k === si); });
      pi.forEach(function (m, k) { m.classList.toggle('on', k === si); });
      ul.classList.remove('auto'); void ul.offsetWidth; if (live) ul.classList.add('auto');
    }
    function loop() { clearInterval(tm); if (live) tm = setInterval(function () { step(si + 1); }, 3200); }
    stp.forEach(function (l, k) {
      var go = function () { live = false; clearInterval(tm); step(k); };
      l.addEventListener('mouseenter', go); l.addEventListener('click', go); l.addEventListener('focus', go);
    });
    ul.addEventListener('mouseleave', function () { live = true; step(si); loop(); });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      new IntersectionObserver(function (e) { if (e[0].isIntersecting) { step(si); loop(); } else clearInterval(tm); }).observe(ul);
    }
  })();

  /* ---------- apparitions, compteurs, inclinaison (maquette) ; filet : tout est visible après 4 s ---------- */
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = qa('.rvl');
  if (!('IntersectionObserver' in window) || reduce) els.forEach(function (e) { e.classList.add('in'); });
  else {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { threshold: .18, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  setTimeout(function () { els.forEach(function (e) { e.classList.add('in'); }); }, 4000);
  var fmt = function (x, d) { return x.toLocaleString('fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d }); };
  qa('[data-count]').forEach(function (el) {
    var to = parseFloat(el.dataset.count), d = +(el.dataset.dec || 0), done = false;
    if (reduce || !('IntersectionObserver' in window)) return;
    var o = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting || done) return; done = true; var t0 = null;
      function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(to * e, d); if (k < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }, { threshold: .6 }); o.observe(el);
  });
  if (!reduce && matchMedia('(hover:hover)').matches) {
    qa('.tilt').forEach(function (c) {
      c.addEventListener('pointermove', function (ev) { var r = c.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5; c.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg'); });
      c.addEventListener('pointerleave', function () { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); });
    });
  }
})();
